import { useState } from "react";
import { motion } from "framer-motion";
import { Send, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { submitFeedback } from "@/api";

export const NegativeOutcome = ({ slug, rating, onSubmit }) => {
  const [feedback, setFeedback] = useState("");
  const [sending, setSending] = useState(false);

  const handleSubmit = async () => {
    if (sending) return;
    setSending(true);
    try {
      await submitFeedback(slug, { rating, feedback: feedback.trim() || null });
      onSubmit();
    } catch {
      toast.error("No se ha podido enviar. Inténtalo de nuevo.");
      setSending(false);
    }
  };

  return (
    <motion.div
      key="negative"
      initial={{ opacity: 0, y: 16 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -12 }}
      transition={{ duration: 0.35, ease: "easeOut" }}
      className="w-full flex flex-col gap-7"
      data-testid="negative-outcome"
    >
      <div className="text-center space-y-3">
        <h2
          data-testid="negative-heading"
          className="font-serif-display text-3xl sm:text-4xl font-medium tracking-tight text-[#1C1917] leading-snug"
        >
          Gracias por tu valoración.
        </h2>
        <p className="text-base text-[#57534E] leading-relaxed">
          ¿Quieres contarnos qué podríamos mejorar?
        </p>
      </div>

      <div className="flex flex-col gap-2">
        <label
          htmlFor="feedback-textarea"
          className="font-mono-label text-[10px] uppercase tracking-[0.25em] text-[#A8A29E] px-1"
        >
          Comentario · Opcional
        </label>
        <textarea
          id="feedback-textarea"
          data-testid="feedback-textarea"
          value={feedback}
          onChange={(e) => setFeedback(e.target.value)}
          placeholder="Cuéntanos cómo podemos mejorar... (opcional)"
          rows={4}
          className="w-full resize-none rounded-xl border border-[#E7E2D7] bg-white/90 px-4 py-3.5 text-base text-[#1C1917] placeholder:text-[#A8A29E] shadow-[inset_0_1px_2px_rgba(28,25,23,0.03)] focus:outline-none focus:ring-2 focus:ring-[#C25E38]/30 focus:border-[#C25E38]/50 transition-shadow duration-200"
        />
      </div>

      <motion.button
        type="button"
        data-testid="submit-feedback-button"
        disabled={sending}
        onClick={handleSubmit}
        whileHover={!sending ? { scale: 1.02 } : undefined}
        whileTap={!sending ? { scale: 0.97 } : undefined}
        className="w-full flex items-center justify-center gap-2.5 bg-[var(--brand-primary)] hover:bg-[var(--brand-accent)] disabled:bg-[#E7E5E4] disabled:text-[#A8A29E] disabled:cursor-not-allowed text-[#FDFBF7] font-medium text-base rounded-xl px-6 py-4 transition-colors duration-300 cursor-pointer"
      >
        {sending ? "Enviando..." : "Enviar opinión"}
        {sending ? (
          <Loader2 className="h-4 w-4 animate-spin" data-testid="submit-feedback-loading" />
        ) : (
          <Send className="h-4 w-4" />
        )}
      </motion.button>
    </motion.div>
  );
};
